import { render } from "./RectangleItemFullImage.vue?vue&type=template&id=33f56627&scoped=true&ts=true"
import script from "./RectangleItemFullImage.vue?vue&type=script&lang=ts"
export * from "./RectangleItemFullImage.vue?vue&type=script&lang=ts"

import "./RectangleItemFullImage.vue?vue&type=style&index=0&id=33f56627&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33f56627"]])

export default __exports__